import React from 'react';
import PropTypes from 'prop-types';
import _e from 'common/localeUtil';
import FormFieldOneInput from './fields/FormFieldOneInput';

const FacebookPixelForm = ({ errorMessage }) => {
	return (
		<FormFieldOneInput
			errorMessage={errorMessage}
			description={_e('facebook_pixel_desc')}
			fieldName="facebook_pixel"
			placeholder={_e('facebook_pixel_id')}
			help={
				<span>
					<a
						href="https://www.facebook.com/business/learn/facebook-ads-pixel"
						target="_blank"
						rel="noopener noreferrer"
					>
						{_e('how_to_get_fb_pixel')}
					</a>
					&nbsp; {_e('fb_pixel_desc')}
				</span>
			}
		/>
	);
};

FacebookPixelForm.propTypes = {
	errorMessage: PropTypes.string,
};

export default FacebookPixelForm;
